<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uOKcx2/tc-custom/9781452112817.jpg?1700538730734" alt="This image is the cover for the book Slow Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Slow Fire
      </h1>
      <p class="bookDescription body article font2">
        <b>The Hall of Fame pitmaster and author of <i>Flavorize</i> “does a great job of explaining the hows and whys behind this particular cooking method” (<i>Epicurious</i>).</b><br/><br/>Great barbecue is as simple as meat, fire, smoke, and time. This ode to authentic meaty goodness gives barbecue beginners an essential guide to the tools, techniques, and recipes needed to make smoky, mouthwatering, fall-off-the-bone meats. And seasoned smokers will learn a thing or two, too! Ray Lampe, a.k.a. Dr. BBQ, brings decades of expertise as a barbecue master, providing indispensable wisdom alongside 68 of the best recipes he has encountered in his long and wide-ranging career, from tantalizing mains such as Competition-Style Beef Brisket to lip-smacking sides such as Bacon and Blue Cheese Coleslaw. For both stove-top smokers and regular backyard grills, <i>Slow Fire </i>makes it easy to cook irresistible slow-cooked barbecue right at home.<br/><br/><b>“If you’re a beginner looking to expand your cooking skills into the fine art of barbecue, <i>Slow Fire </i>will surely set you in the right direction. The book is not intimidating in stature, but complete in guidance. I firmly believe Ray Lampe can teach you to barbecue with just one book.” —<i>Top Ribs</i></b><br/><br/><b>“Anyone with a penchant for perfecting their barbecue techniques can benefit . . . there is more than enough information here to have an endless number of feasts.” —<i>Tap into Morristown</i></b><br/><br/><b>“A fun book . . . This one takes a much more laid back approach. That’s to my liking. The recipes here could keep your grill happy all summer long.” —<i>Foodamental</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ray Lampe, Famous Dave Anderson, Leigh Beisch
      </h2>
      
      <p class="authorDescription body article">Ray "Dr. BBQ" Lampe has been barbecuing professionally for over 20 years and is a cook-off champion. He has written 5 cookbooks, including Ribs, Chops, Steaks & Wings. He lives in Florida.Leigh Beisch is a San Francisco–based photographer whose work can be found in Ribs, Chops, Steaks & Wings."Famous Dave" Anderson, founder of the successful barbecue restaurant chain Famous Dave's of America, is a grilling and bbq expert, best-selling author and motivational speaker.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?072b1372